module.exports = __webpack_public_path__ + "static/media/20191117.9898f254.jpg";